import React from "react";
import "./OrderConfirmed.scss";

const OrderConfirmed = ({ history }) => {
  return (
    <div className="OrderConfirmed">
      <div className="oc-content">
        <h1>Thank You!</h1>
        <p>
          Dear Customer! Your Order has been Confirmed. You will Receive an
          Email Shortly.
        </p>
        <p>
          You will Recieve a Text or Call For Order Confirmation on Your Number
          1/2 days Prior to Your Delivery Day.
        </p>
        <div className="feedback">
          <button onClick={() => history.push("/")} className="home">
            Back to Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default OrderConfirmed;
